<template>
  <div class="va-pay">
    <div class="va-container">
      <div class="va-header">
        <img v-if="isAO" :src="expressLogo" class="va-title-logo" alt="Bank Transfer" />
        <div v-else class="va-title">{{ $t('text_bank_transfer') }}</div>
      </div>

      <div v-if="!isAccountSubmitted || (!isAO && !shouldShowNumberInput)" class="va-amount-box">
        <div class="va-amount-label">{{ isAO ? $t(vaAmountLabelKey) : 'Amount' }}</div>
        <div class="va-amount-value">
          <span>{{ countryInfo?.currencyCode || 'AOA' }}</span>
          <span class="va-amount-num">{{ formattedPaymentAmount }}</span>
        </div>
      </div>

      <!-- AO 国家：仅在收银台页（已提交后）才显示三排 -->
      <div v-if="isAO && isAccountSubmitted" class="va-info-card-ao">
        <div class="va-info-item-ao">
          <div class="va-info-item-ao-content">
            <div class="va-info-label">{{ $t(vaAmountLabelKey) }}</div>
            <div class="va-info-value va-info-highlight">
              {{ formattedPaymentAmount }}
            </div>
          </div>
        </div>
        <div class="va-info-item-ao" @click="onCopy(vaAccount)">
          <div class="va-info-item-ao-content">
            <div class="va-info-label">{{ $t('text_va_reference') }}</div>
            <div class="va-info-value va-info-highlight va-info-value-copyable">
              <span class="va-info-value-text">{{ vaAccount || '--' }}</span>
            </div>
          </div>
          <img class="va-info-copy-btn" src="@/assets/copy.png" alt="copy" />
        </div>
        <div class="va-info-item-ao" @click="onCopy(bankCode)">
          <div class="va-info-item-ao-content">
            <div class="va-info-label">{{ $t('text_va_institution_id') }}</div>
            <div class="va-info-value va-info-value-copyable">
              <span class="va-info-value-text">{{ bankCode || '--' }}</span>
            </div>
          </div>
          <img class="va-info-copy-btn" src="@/assets/copy.png" alt="copy" />
        </div>
      </div>

      <!-- 非 AO 国家：保持原 VA 卡（两行 Reference / Bank Code） -->
      <div
        v-if="!isAO && !shouldShowNumberInput"
        class="va-info-card"
      >
        <div class="va-info-item" @click="onCopy(vaAccount)">
          <div class="va-info-label">{{ $t('text_va_account') }}</div>
          <div class="va-info-value va-info-highlight">{{ vaAccount || '--' }}</div>
          <div class="va-info-copy">{{ $t('text_va_tap_to_copy') }}</div>
        </div>
        <div class="va-info-divider"></div>
        <div class="va-info-item" @click="onCopy(bankCode)">
          <div class="va-info-label">{{ $t('text_va_bank_code') }}</div>
          <div class="va-info-value">{{ bankCode || '--' }}</div>
          <div class="va-info-copy">{{ $t('text_va_tap_to_copy') }}</div>
        </div>
      </div>

      <div class="va-timer" v-if="hr && (!shouldShowNumberInput || isAccountSubmitted)">
        <span>{{ $t('text_remaining_time') }}: </span>
        <span class="va-timer-value">{{ hr }}:{{ min }}:{{ sec }}</span>
      </div>

      <div v-if="isAccountSubmitted && isAO" class="va-multicaixa-hint">
        {{ $t('text_va_multicaixa_hint') }}
      </div>

      <div
        v-if="shouldShowNumberInput && !isAccountSubmitted"
        class="moblie_pay_container_step_account"
      >
        <div class="moblie_pay_container_step_account_input_box">
          <div class="moblie_pay_container_step_233">+{{ countryInfo?.phoneCode }}</div>
          <input
            v-model="paymentAccount"
            class="moblie_pay_container_step_account_input"
            type="text"
            :maxlength="phoneMaxLength"
            :placeholder="$t('text_please_enter_your_actual_payment_account')"
          />
        </div>
        <div
          @click="paymentAccountSubmit"
          class="moblie_pay_container_step_account_submit_box"
        >
          <div
            class="moblie_pay_container_step_account_submit"
            :class="{ 'is-loading': paymentAccountSubmitting }"
          >
            <div class="moblie_pay_container_step_account_submit_text">
              {{ $t('text_confirm') }}
            </div>
          </div>
        </div>
      </div>

      <div class="va-notice">
        {{ $t('text_va_notice') }}
      </div>
    </div>
  </div>
</template>

<script>
import logic from "./index.js";
export default {
  name: "LinkedPayVAMoblie",
  mixins: [logic],
};
</script>

<style lang="scss" scoped>
.va-pay {
  min-height: 100vh;
  background: #f5f5f5;
}

.va-container {
  padding: 40px 20px 0;
}

.va-header {
  text-align: center;
  margin-bottom: 24px;
}

.va-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.va-title-logo {
  max-width: 160px;
  height: auto;
  object-fit: contain;
  display: inline-block;
}

.va-desc {
  font-size: 13px;
  color: #888;
  line-height: 1.4;
}

.va-amount-box {
  text-align: center;
  margin-bottom: 28px;
}

.va-amount-label {
  font-size: 13px;
  color: #888;
  margin-bottom: 4px;
}

.va-amount-value {
  font-size: 14px;
  color: #524535;
  font-weight: 500;
}

.va-amount-num {
  font-size: 22px;
  color: #DC811D;
  margin-left: 4px;
}

.va-multicaixa-hint {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  margin: 12px 0 20px;
  text-align: center;
}

.va-info-card-ao {
  background: #fff;
  border-radius: 12px;
  padding: 0;
  margin-bottom: 20px;
  box-shadow: 0 1px 8px rgba(0,0,0,0.06);
  overflow: hidden;
}

.va-info-item-ao {
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  position: relative;

  &:active {
    background: #f9f9f9;
  }
}

.va-info-item-ao-content {
  flex: 1;
  min-width: 0;
}

.va-info-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 6px;
}

.va-info-value {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  word-break: break-all;
}

.va-info-highlight {
  font-size: 18px;
  color: #DC811D;
  font-weight: 600;
}

.va-info-value-copyable {
  font-size: 14px;
}

.va-info-value-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.va-info-copy-btn {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-left: auto;
}

.va-info-card {
  background: #fff;
  border-radius: 12px;
  padding: 0;
  margin-bottom: 20px;
  box-shadow: 0 1px 8px rgba(0,0,0,0.06);
  overflow: hidden;
}

.va-info-item {
  padding: 18px 20px;
  cursor: pointer;
  position: relative;

  &:active {
    background: #f9f9f9;
  }
}

.va-info-copy {
  font-size: 11px;
  color: #bbb;
  margin-top: 4px;
}

.va-info-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 0 20px;
}

.va-timer {
  text-align: center;
  margin-top: 16px;
  font-size: 13px;
  color: #888;

  .va-timer-value {
    font-weight: 600;
    color: #DC811D;
  }
}

.va-notice {
  text-align: center;
  margin-top: 24px;
  font-size: 11px;
  color: #aaa;
  line-height: 1.5;
}

.moblie_pay_container_step_account {
  margin-top: 16px;

  .moblie_pay_container_step_account_input_box {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 6px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #cccccc;

    .moblie_pay_container_step_233 {
      width: 40px;
      color: #dc811d;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
    }
  }

  .moblie_pay_container_step_account_input {
    width: 100%;
    height: 100%;
    border: none;
    box-sizing: border-box;
    outline: none;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #000000;

    &::placeholder {
      line-height: 18px;
      font-size: 11px;
      color: #b6b6b6;
    }
  }

  .moblie_pay_container_step_account_submit_box {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .moblie_pay_container_step_account_submit {
    width: 150px;
    height: 34px;
    padding: 0 18px;
    box-sizing: border-box;
    background: #e68608;
    border-radius: 23px;
    border: 1px solid #e68608;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    color: #ffffff;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &.is-loading {
      opacity: 0.6;
      pointer-events: none;
    }
  }
}
</style>